export const EN = {
    languageCode: "en",
    legal: {
        contact: "Contact",
        imprint: "Imprint",
        agb: "AGB",
        dataProtection: "Data protection",
    },
};
//# sourceMappingURL=en.js.map